/* eslint-disable */
export default {
  _ostrich_sansheavy: 'ostrich_sansheavy',
  _bpreplaybold: 'bpreplaybold',
  _bpreplayregular: 'bpreplayregular',
  _lemon_milkregular: 'lemon_milkregular',
}